export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"preconnect","href":"https://www.zeronet.co.nz","crossorigin":"anonymous"},{"rel":"preload","as":"image","href":"/resized-images/hero-828.avif","imagesrcset":"/resized-images/hero-1920.avif 1920w, /resized-images/hero-1600.avif 1600w, /resized-images/hero-1440.avif 1440w, /resized-images/hero-1366.avif 1366w, /resized-images/hero-1024.avif 1024w, /resized-images/hero-828.avif 828w","imagesizes":"100vw","fetchpriority":"high","type":"image/avif","media":"(min-width: 828px)"},{"rel":"preload","as":"image","href":"/resized-images/hero-480.avif","imagesrcset":"/resized-images/hero-768.avif 768w, /resized-images/hero-640.avif 640w, /resized-images/hero-480.avif 480w","imagesizes":"100vw","fetchpriority":"high","type":"image/avif","media":"(max-width: 827px)"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"512x512","href":"/favicon.png"},{"rel":"dns-prefetch","href":"https://data.zeronet.co.nz"},{"rel":"preconnect","href":"https://data.zeronet.co.nz","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://connect.facebook.net"},{"rel":"preconnect","href":"https://connect.facebook.net","crossorigin":"anonymous"},{"rel":"preload","href":"/fonts/dehinted-RebondGrotesque-Semibold.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous","fetchpriority":"high"},{"rel":"preload","href":"/fonts/dehinted-Rubik-Regular.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous","fetchpriority":"high"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"en"},"charset":"utf-8","viewport":"width=device-width, initial-scale=1","title":"Unlimited Internet | Zeronet","titleTemplate":"%s | Zeronet"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true